import { DESIGN } from "../data/balance.js";

/**
 * design 비율 상한 — 극단적으로 길쭉한 화면(폴더블 등)에서 캔버스가 무한정 늘어나지 않도록 cap.
 * DESIGN.width(390) × 2.5 = 975. 이보다 길쭉한 화면은 하단 레터박스가 일부 남는다(허용).
 */
export const MAX_DESIGN_HEIGHT = Math.round(DESIGN.width * 2.5);

/** {@link resolveDesignHeight} 입력 — 캔버스 부모(#game-root)의 레이아웃 px 또는 화면 px. */
export interface ScreenSize {
  width: number;
  height: number;
}

/**
 * 화면 비율에 맞춘 동적 design 높이 산출 — 가로(width)는 DESIGN.width 고정, 세로만 화면 비율을 추종해
 * 길쭉한 기기(Flip6 22:9 등)에서 FIT 레터박스(하단 공백)를 제거한다. `deriveShellLayout`이 이 높이의
 * 여분(designHeight−DESIGN.height)을 게임뷰 영역에 흡수해 탭바를 화면 하단에 붙인다.
 *
 * - 하한 DESIGN.height(844): design 비율(844/390≈2.164)보다 덜 길쭉한 기기(태블릿·정사각형)는 844
 *   유지 → 기존과 정확히 동일(회귀 0). 일반 폰(2.16~2.22)은 여분이 작아 미세 흡수.
 * - 상한 MAX_DESIGN_HEIGHT(975): 극단 비율 cap — 그 이상 길쭉하면 하단 레터박스 일부 잔존.
 * - 0/음수 화면은 844 폴백(미마운트 순간 방어).
 */
export function resolveDesignHeight(screen: ScreenSize): number {
  if (screen.width <= 0 || screen.height <= 0) return DESIGN.height;
  const desired = DESIGN.width * (screen.height / screen.width);
  return Math.min(Math.max(desired, DESIGN.height), MAX_DESIGN_HEIGHT);
}
